
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCommonSupplement} from "@/models/app/common/supplement";

// Components
import {
  ElDialog,
  ElButton,
} from "element-plus";
import {Search} from "@element-plus/icons-vue";

@Options({
  props: [
    "supplement",
  ],
  components: {
    ElDialog,
    ElButton,
    Search,
  },
})
export default class AppPlayerResourcesSupplementsListFormLookupIndexVue extends Vue {
  isDialogVisible: boolean | null = false;

  supplement: AppCommonSupplement = new AppCommonSupplement();
}
